// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../../textstyles/fonts.css";
import "../../reset.css";
import "./CustomerMenuItem.ChangeQuantity.QuantityButton.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../../_internal_utils";
import { RootPrimitive, IconPrimitive } from "../../_internal_primitives";
import * as icons from "../../icons";

const styles = [
  {
    type: "default",
    layers: {
      UJjHNrcwEd: {
        none: {
          icon: icons.plus,
          useMask: true,
        },
      },
    },
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const QuantityButtonContext = createContext(null);

function QuantityButton(_props) {
  const defaults = useContext(QuantityButtonContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="JvFxHPy1UT"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "JvFxHPy1UT",
        scope: "MXKZozgeDx",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <IconPrimitive
          id={"Icon_UJjHNrcwEd"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_MXKZozgeDx_UJjHNrcwEd"
          }
          key={"UJjHNrcwEd"}
          useMask={getStyle("UJjHNrcwEd", "useMask")}
          src={exists(props.icon) ? props.icon : getStyle("UJjHNrcwEd", "icon")}
        />
      )}
    </RootPrimitive>
  );
}

QuantityButton.__variants = [];

export default QuantityButton;
